export default "__VITE_PUBLIC_ASSET__bee8be0a__"